package com.patronat.top.ui.organisms.table

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.*

data class TableColumn<T>(
    val title: String,
    val widthWeight: Float = 1f,
    val alignment: Alignment.Horizontal = Alignment.Start,
    val content: @Composable (T) -> Unit
)

@Composable
fun <T> AppDataTable(
    columns: List<TableColumn<T>>,
    data: List<T>,
    modifier: Modifier = Modifier,
    onRowClick: ((T) -> Unit)? = null
) {
    val tableShape = RoundedCornerShape(12.dp)

    Column(
        modifier = modifier
            .fillMaxWidth()
            .clip(tableShape)
            .border(1.dp, MineShaft100, tableShape)
            .background(White)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .background(White)
                .padding(horizontal = 24.dp, vertical = 16.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            columns.forEach { column ->
                Box(
                    modifier = Modifier.weight(column.widthWeight),
                    contentAlignment = when (column.alignment) {
                        Alignment.Start -> Alignment.CenterStart
                        Alignment.End -> Alignment.CenterEnd
                        Alignment.CenterHorizontally -> Alignment.Center
                        else -> Alignment.CenterStart
                    }
                ) {
                    Text(
                        text = column.title.uppercase(),
                        style = TableHeadTextStyle,
                        maxLines = 1
                    )
                }
            }
        }

        HorizontalDivider(color = MineShaft100, modifier = Modifier.padding(horizontal = 24.dp))

        LazyColumn(
            modifier = Modifier.fillMaxWidth()
        ) {
            items(data) { item ->
                Column(
                    modifier = Modifier.then(
                        if (onRowClick != null) {
                            Modifier.clickable { onRowClick(item) }
                        } else {
                            Modifier
                        }
                    )
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 24.dp, vertical = 16.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        columns.forEach { column ->
                            Box(
                                modifier = Modifier.weight(column.widthWeight),
                                contentAlignment = when (column.alignment) {
                                    Alignment.Start -> Alignment.CenterStart
                                    Alignment.End -> Alignment.CenterEnd
                                    Alignment.CenterHorizontally -> Alignment.Center
                                    else -> Alignment.CenterStart
                                }
                            ) {
                                column.content(item)
                            }
                        }
                    }
                    HorizontalDivider(color = MineShaft50, modifier = Modifier.padding(horizontal = 24.dp))
                }
            }
        }
    }
}
